import template from './checkoutAddress.html';

import _ from 'lodash';

class CheckoutAddressController {
    /*@ngInject*/
    constructor(constants) {
        this.constants = constants;
    }

    $onInit() {
        this.isEditMode = false;
    }

    onSave() {
        if (_.isFunction(this.onChanged)) {
            this.onChanged(this.address)
                .then((result) => {
                    this.address = result;
                });
        } 
        this.isEditMode = false;
    }

    formatAddressName() {
        let street = this.address.Address1;
        if (!_.isEmpty(this.address.Address2)) {
            street = `${street} ${this.address.Address2}`;
        }
        return `${street}, ${this.address.City}, ${this.address.State.code} ${this.address.PostalCode}`;
    }
}

export default {
template: template,
    bindings: {
    address : '<',
    addressType: '<',
    countries: '<',
    states: '<',
    onChanged: '<'
    },
controller: CheckoutAddressController
};